document.addEventListener("DOMContentLoaded", function(){

    const thumbs=document.querySelectorAll(".gallery-thumb");
    const main=document.getElementById("galleryMainImage");

    thumbs.forEach(function(thumb){

        thumb.addEventListener("click",function(){

            main.src=this.dataset.full;

            document
            .querySelectorAll(".gallery-thumb")
            .forEach(t=>t.classList.remove("active"));

            this.classList.add("active");

        });

    });

});